import { render, staticRenderFns } from "./GenericAccountImport.vue?vue&type=template&id=ec3d4526"
import script from "./GenericAccountImport.vue?vue&type=script&lang=js"
export * from "./GenericAccountImport.vue?vue&type=script&lang=js"
import style0 from "./GenericAccountImport.vue?vue&type=style&index=0&id=ec3d4526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports